export const ANIMATION_DURATION_SECONDS = 0.25;
export const AVATAR_TRANSITION_DURATION = ANIMATION_DURATION_SECONDS * 1.25;
